export interface Config {
  id: number;
  name: string;
  value: string;
}

export enum CronJobStatus {
  ENABLED = 'Enabled',
  DISABLED = 'Disabled',
}

export enum TaskType {
  Event = 'Event',
  ConfirmJobs = 'ConfirmJobs',
  MonthlyInvoice = 'MonthlyInvoice',
  DeactivateExpiredPostSchedules = 'DeactivateExpiredPostSchedules',
  PostToFacebookPages = 'PostToFacebookPages',
  DellaFacebookAccessToken = 'DellaFacebookAccessToken',
}

export const cronJobLabels: Partial<Record<TaskType, string>> = {
  [TaskType.ConfirmJobs]: 'CONFIRM_JOBS',
  [TaskType.DeactivateExpiredPostSchedules]: 'DEACTIVATE_EXPIRED_POST_SCHEDULES',
  [TaskType.Event]: 'EVENT',
  [TaskType.MonthlyInvoice]: 'MONTHLY_INVOICE',
  [TaskType.PostToFacebookPages]: 'POST_TO_FACEBOOK_PAGES',
};

export const configValueLabels: Partial<Record<TaskType, string>> = {
  [TaskType.DellaFacebookAccessToken]: 'DELLA_FACEBOOK_ACCESS_TOKEN',
};

export interface TokenExpiration {
  accessTokenExpirationDate: string;
  aboutToExpire: boolean;
  currentToken: string;
}

export interface TokenRenew {
  shortLivedToken: string;
}
